<template>
  <ul style="padding-inline-start: 0px; list-style: none;">
    <li v-for="studentAttention in attentions" :key="studentAttention.id">
      <attentions-by-type-item
        :bordered-header="true"
        :attention="studentAttention"
        style="margin: 10px 0;"
        @finish-attention="finishAttention"
      >
        <template slot="subheader">{{ attentionStatus(studentAttention) }}</template>

        <div class="meta-list">
          <hr />

          <div
            v-if="studentAttention.participationOf && studentAttention.participationOf['comment']"
            class="meta-item"
          >
            <span class="meta-name has-text-weight-bold">Resultado:</span>
            <span class="meta-value">{{ studentAttention.participationOf["comment"] }}</span>
          </div>
          <div
            v-if="
              studentAttention.status !== 'FAILED' &&
                studentAttention.participationOf &&
                studentAttention.participationOf['evaluation']
            "
            class="meta-item"
          >
            <span class="meta-name has-text-weight-bold">Evaluación:</span>
            <span class="meta-value">
              <button class="emotion">
                {{ evaluationIconScore[studentAttention.participationOf["evaluation"]] }}
              </button>
            </span>
          </div>
          <div class="meta-item">
            <span class="meta-name has-text-weight-bold">Fecha de cierre:</span>
            <span class="meta-value">{{ studentAttention.performedAt | formatStandardDate }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-name has-text-weight-bold">Responsable de cierre:</span>
            <span class="meta-value">{{ finishedByUser(studentAttention) }}</span>
          </div>
        </div>
        <div class="description">
          <i></i>
        </div>
      </attentions-by-type-item>
    </li>
  </ul>
</template>

<script>
import moment from "moment"
import AttentionsByTypeItem from "@/components/_base/AttentionsByTypeItem.vue"

export default {
  name: "AttentionsByTypeBody",

  components: {
    AttentionsByTypeItem
  },

  props: {
    attentions: {
      type: Array
    }
  },

  data() {
    return {
      evaluationIconScore: { YAY: ":)", MEH: ":|", SAD: ":(" }
    }
  },

  methods: {
    attentionStatus(attention) {
      let status
      if (attention.status == "PENDING") status = "pendiente"
      if (attention.status == "COMPLETED") status = "realizada"
      if (attention.status == "FAILED") status = "fallida"
      return status
    },
    finishedByUser(studentAttention) {
      if (studentAttention.finishedBy) {
        return studentAttention.finishedBy.name
      } else {
        return "-"
      }
    },
    finishAttention(attentionId) {
      this.$emit("finish-attention", attentionId)
    }
  },

  filters: {
    formatStandardDate(date) {
      if (date === null) {
        return "-"
      } else {
        return moment(date).format("DD/MM/YYYY")
      }
    }
  }
}
</script>
